import {
    blogsArticleCreateUrl,
    blogsArticleEditUrl,
    blogsArticleUrl,
    blogsEntityLikersUrl,
    blogsShortMessageEditUrl,
    blogsShortMessageUrl,
} from 'mk2/apps/blogs/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'blogs',
    exact: true,
    path: blogsEntityLikersUrl,
    getPage: () => {
        return import('mk2/apps/blogs/containers/BlogsEntityLikers/BlogsEntityLikersPage' /* webpackChunkName: "blogs.BlogsEntityLikers" */);
    },
    modules: [ 'mk2/apps/blogs/containers/BlogsEntityLikers/BlogsEntityLikersPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsArticleCreateUrl,
    getPage: () => {
        return import('mk2/apps/blogs/containers/ArticleCreate/ArticleCreatePage' /* webpackChunkName: "blogs.ArticleCreate" */);
    },
    modules: [ 'mk2/apps/blogs/containers/ArticleEdit/ArticleCreatePage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsArticleEditUrl,
    getPage: () => {
        return import('mk2/apps/blogs/containers/ArticleEdit/ArticleEditPage' /* webpackChunkName: "blogs.ArticleEdit" */);
    },
    modules: [ 'mk2/apps/blogs/containers/ArticleEdit/ArticleEditPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsArticleUrl,
    getPage: () => {
        return import('mk2/apps/blogs/containers/Article/ArticlePage' /* webpackChunkName: "blogs.Article" */);
    },
    modules: [ 'mk2/apps/blogs/containers/Article/ArticlePage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsShortMessageUrl,
    getPage: () => {
        return import('mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage' /* webpackChunkName: "blogs.BlogsShortMessageDetail" */);
    },
    modules: [ 'mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetailPage' ],
}, {
    app: 'blogs',
    exact: true,
    path: blogsShortMessageEditUrl,
    getPage: () => {
        return import('mk2/apps/blogs/containers/BlogsShortMessageEdit/BlogsShortMessageEditPage' /* webpackChunkName: "blogs.BlogsShortMessageEdit" */);
    },
    modules: [ 'mk2/apps/blogs/containers/BlogsShortMessageEdit/BlogsShortMessageEditPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupFeed/GroupFeedPage' /* webpackChunkName: "blogs.GroupFeed" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupFeed/GroupFeedPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupReportedUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupReportedFeed/GroupReportedFeedPage' /* webpackChunkName: "blogs.GroupReportedFeed" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupReportedFeed/GroupReportedFeedPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsNewGroupExplanationUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupCreateExplanation/GroupCreateExplanationPage' /* webpackChunkName: "blogs.GroupCreateExplanation" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupCreateExplanation/GroupCreateExplanationPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsNewGroupSelectUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupCreateSelect/GroupCreateSelectPage' /* webpackChunkName: "blogs.GroupCreateSelect" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupCreateSelect/GroupCreateSelectPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsNewGroupFormUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupCreate/GroupCreatePage' /* webpackChunkName: "blogs.GroupCreate" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupCreate/GroupCreatePage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsListUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/ListOfGroups/ListOfGroupsPage' /* webpackChunkName: "blogs.ListOfGroups" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/ListOfGroups/ListOfGroupsPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsEntityLikersUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupEntityLikers/GroupEntityLikersPage' /* webpackChunkName: "blogs.GroupEntityLikers" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupEntityLikers/GroupEntityLikersPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsPostEditUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupPostEdit/GroupPostEditPage' /* webpackChunkName: "blogs.GroupPostEdit" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupPostEdit/GroupPostEditPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupInfoUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupInfo/GroupInfoPage' /* webpackChunkName: "blogs.GroupInfo" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupInfo/GroupInfoPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupPhotosUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupPhotos/GroupPhotosPage' /* webpackChunkName: "blogs.GroupPhotos" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupPhotos/GroupPhotosPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupEditUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupEdit/GroupEditPage' /* webpackChunkName: "blogs.GroupEdit" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupEdit/GroupEditPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupBlockedMembersUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupBlockedMembers/GroupBlockedMembersPage' /* webpackChunkName: "blogs.GroupBlockedMembers" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupBlockedMembers/GroupBlockedMembersPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupInvitedMembersUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupInvitedMembers/GroupInvitedMembersPage' /* webpackChunkName: "blogs.GroupInvitedMembers" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupInvitedMembers/GroupInvitedMembersPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupMembershipRequestsUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupMembershipRequests/GroupMembershipRequestsPage' /* webpackChunkName: "blogs.GroupMembershipRequests" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupMembershipRequests/GroupMembershipRequestsPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupInvitationUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupInvitation/GroupInvitationPage' /* webpackChunkName: "blogs.GroupInvitation" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupInvitation/GroupInvitationPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupBlockMemberUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupBlockMember/GroupBlockMemberPage' /* webpackChunkName: "blogs.GroupBlockMember" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupBlockMember/GroupBlockMemberPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsGroupMembersUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupMembers/GroupMembersPage' /* webpackChunkName: "blogs.GroupMembers" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupMembers/GroupMembersPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsPhotoDetailUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/PhotoDetail/PhotoDetailPage' /* webpackChunkName: "blogs.PhotoDetail" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/PhotoDetail/PhotoDetailPage' ],
// }, {
//     app: 'blogs',
//     exact: true,
//     path: groupsPostDetailUrl,
//     getPage: () => {
//         return import('mk2/apps/blogs/containers/GroupPostDetail/GroupPostDetailPage' /* webpackChunkName: "blogs.GroupPostDetail" */);
//     },
//     modules: [ 'mk2/apps/blogs/containers/GroupPostDetail/GroupPostDetailPage' ],
}];
